/**
 * 创建人：但志强
 * 时间：2019-6-11
 * 描述：将true 和false 转换成是或者否
 * 更新记录: 
 */
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * 将布尔值转换成 是 或者 否
 * @example <td [innerHTML]="data.isPublish | Whether"></td>
 */
@Pipe({name: 'whether' })
export class WhetherPipe implements PipeTransform {

   //获取当前dom节点
  constructor(private dom: DomSanitizer){}

  /**
     * 管道的初始化方法
     * @param value 传入的数据  true 或者f alse
     * @param isReverse 是否反向设置颜色
     */
  transform(value: boolean | number|any,isReverse:boolean ): any {
    if(+value){
      //表面该HTML是可信赖的
      if(isReverse){
        return this.dom.bypassSecurityTrustHtml(`<span class="state-error">是</span>`);
      }
        return this.dom.bypassSecurityTrustHtml(`<span class="state-success">是</span>`);
    } else {
      if(isReverse){
        return this.dom.bypassSecurityTrustHtml(`<span class="state-success">否</span>`);
      }
      return this.dom.bypassSecurityTrustHtml(`<span class="state-error">否</span>`);
    }
  }
}
//前台写法
//<td [innerHTML]="data.isPublish | Whether"></td>